/**
 * @file: AuthTokenMiddleware.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { Middleware } from '@euler/lib/request/Middleware';
import { RequestContext } from '@euler/lib/request/types';
import { defaultTokenService } from '@euler/services/factory';

export class AuthTokenMiddleware implements Middleware {
  async getToken() {
    return await defaultTokenService.getToken();
  }

  async pre(context: RequestContext): Promise<void> {
    const token = await this.getToken();
    if (token) {
      context.init.headers = {
        ...context.init.headers,
        Authorization: `Bearer ${token}`,
      };
    }
  }
}
